import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  tests: null,
  testCount: 0,
  savingTestCategory: false,
  savingCommodityCategory: false,
  savingCommodity: false,
  commodityCategories: [],
  commodities: [],
  testCategories: [],
};

const masterCatalogSlice = createSlice({
  name: "masterCatalog",
  initialState,
  reducers: {
    fetchCatalog(state, action) {
      state.loading = true;
    },
    fetchCatalogSuccess(state, action) {
      state.tests = action.payload.data.document;
      state.testCount = action.payload.count;
      state.loading = false;
    },
    fetchCatalogFailure(state, action) {
      state.loading = false;
    },
    initializeError(state, action) {
      state.error = null;
    },
    saveTestCategory(state, action) {
      state.savingTestCategory = true;
    },
    saveTestCategorySuccess(state, action) {
      state.savingTestCategory = false;
    },
    saveTestCategoryFailure(state, action) {
      state.savingTestCategory = false;
      state.error = action.payload.message;
    },
    saveCommodityCategory(state, action) {
      state.savingCommodityCategory = true;
    },
    saveCommodityCategorySuccess(state, action) {
      state.savingCommodityCategory = false;
    },
    saveCommodityCategoryFailure(state, action) {
      state.savingCommodityCategory = false;
      state.error = action.payload.message;
    },
    saveCommodity(state, action) {
      state.savingCommodity = true;
    },
    saveCommoditySuccess(state, action) {
      state.savingCommodity = false;
    },
    saveCommodityFailure(state, action) {
      state.savingCommodity = false;
      state.error = action.payload.message;
    },
    fetchCommodityCategories(state, action) {
      state.loading = true;
    },
    fetchCommodityCategoriesSuccess(state, action) {
      state.commodityCategories = action.payload.data?.document;
      state.loading = false;
    },
    fetchCommodityCategoriesFailure(state, action) {
      state.loading = false;
    },
    fetchCommodity(state, action) {
      state.loading = true;
    },
    fetchCommoditySuccess(state, action) {
      state.commodities = action.payload.data?.document;
      state.loading = false;
    },
    fetchCommodityFailure(state, action) {
      state.loading = false;
    },
    fetchTestCategory(state, action) {
      state.loading = true;
    },
    fetchTestCategorySuccess(state, action) {
      state.testCategories = action.payload.data?.document;
      state.loading = false;
    },
    fetchTestCategoryFailure(state, action) {
      state.loading = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = masterCatalogSlice;
